import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import ExtractPage from './pages/ExtractPage';
import ProfilesPage from './pages/ProfilesPage';
import ComparePage from './pages/ComparePage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/extract" element={<ExtractPage />} />
            <Route path="/profiles" element={<ProfilesPage />} />
            <Route path="/compare" element={<ComparePage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
